// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getStore} from '../../store-factory';
import {getUserSecurity} from '../../user/shared/repositories';

export const updateSelectedSapEnvironment = newValue =>
    async dispatch => {

        dispatch({
            payload: newValue,
            type: actions.UPDATE_SELECTED_SAP_ENVIRONMENT
        });

        await getUserSecurity(getStore());

    };



// WEBPACK FOOTER //
// ./src/app-config/action-creators/sap-environment.js